// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"115":"d1fd2ac2","511":"d1fd2ac2","664":"d1fd2ac2"}[chunkId] + ".chunk.css";
};